__turbopack_context__.v({
  "actionGroup": "styles-module__AgYl4G__actionGroup",
  "paymentWrapper": "styles-module__AgYl4G__paymentWrapper",
  "shipping": "styles-module__AgYl4G__shipping",
  "total": "styles-module__AgYl4G__total",
  "totalPrice": "styles-module__AgYl4G__totalPrice",
  "totalPriceWrapper": "styles-module__AgYl4G__totalPriceWrapper",
});
